module.exports = __webpack_public_path__ + "static/media/screenshot(49).8f858925.jpg";